import { z } from "zod";

const reportStatusSchema = z.enum([
  "InProgress",
  "Complete",
  "Error",
  "PendingAuth",
]);

export const spendInsightsCompanySchema = z.object({
  id: z.string(),
  name: z.string(),
  reportsOverview: z
    .object({
      id: z.string(),
      lastUpdatedUtc: z.string().datetime(),
      outputTypes: z.array(z.string()),
      reportType: z.enum(["spendAnalysis", "spendSummary"]),
    })
    .optional(),
  status: reportStatusSchema,
});

export const spendInsightsCompaniesSchema = z.object({
  results: z.array(spendInsightsCompanySchema),
  pageNumber: z.number(),
  pageSize: z.number(),
  totalResults: z.number(),
  _links: z.object({
    self: z.object({ href: z.string() }).optional(),
    next: z.object({ href: z.string() }).optional(),
    previous: z.object({ href: z.string() }).optional(),
  }),
});

export type SpendInsightsCompany = z.infer<typeof spendInsightsCompanySchema>;
export type SpendInsightsCompanies = z.infer<
  typeof spendInsightsCompaniesSchema
>;

export const fileDownloadSchema = z.object({
  data: z.object({
    size: z.number(),
    type: z.enum(["application/octet-stream"]).optional(),
  }),
  fileName: z.string(),
});

export type FileDownload = z.infer<typeof fileDownloadSchema>;
export type ReportStatus = z.infer<typeof reportStatusSchema>;
